
;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.LeaguesInvites = Marionette.ItemView.extend({
		template: null,
		data: {},
		ui: {
			add_invite:      '',
			send_invites:    '',
			input_invite:    '',
			share_btn:       '',
			gmail_btn:       '',
			modal_container: '',
			modal:           '',
			modal_content:   '',
			select:          '',
			select_all:      ''
		},
		events: {
			'click @ui.add_invite':    'initData',
			'click @ui.send_invites':  'sendInvites',
			'change @ui.input_invite': 'changeInvite',
			'click @ui.share_btn':     'shareInvite',
			'click @ui.gmail_btn':     'showModal',
			'change @ui.select':       'toggleModalCheckbox',
			'change @ui.select_all':   'toggleModalCheckbox',
			'click @ui.modal_close':   'closeModal',
			'click @ui.modal_submit':  'submitModal'
		},
		initialize: function() {
			this.scrollToTop();
			this.league_id     = this.getOption('league_id');
			this.league        = this.getOption('league');
			this.share         = this.getOption('share');
			this.invites       = this.getOption('invites');
			this.user          = this.getOption('user');
			this.google_config = {
				client_id:        CONFIG.GOOGLE_CLIENT_ID, // for local test only!!! '201531739474-ks27ghhpd2m5q9pb938ckucj4t0mh79h.apps.googleusercontent.com',
				api_key:          CONFIG.GOOGLE_API_KEY, // for local test only!!! 'AIzaSyB8UKeffTMpa7vXgGvNUw0ohG8JZNqJeGs',
				scope:            'https://www.googleapis.com/auth/contacts.readonly',
				max_results:      100,
				v:                3.0,
				url_template:     _.template('https://www.google.com/m8/feeds/contacts/default/full?' +
					'access_token=<%- access_token %>&' +
					'alt=json&max-results=<%- max_results %>&' +
					'v=<%- v %>'),
				contact_template: _.template('<label class="base-checkbox"><span><%- name %> (<%- email %>)</span>' +
					'<input type="checkbox" class="<%- class_name %>" data-name="<%- name %>" data-email="<%- email %>"><i></i></label>')
			};
			this.getting_data  = false;

			this.listenTo(this.league, 'leagues:errors', this.showErrors);
			this.listenTo(this.league, 'leagues:invite:success', this.invitesSent);
			this.listenTo(APP.vent, 'leagues_manage_controls:change_league', this.changeLeague);

			var complete = [
				this.league.show().fetch({ data:{ id: this.league_id } })
			];

			$.when.apply(null, complete).done(_.bind(this.initData, this));
		},
		initData: function() {
			this.league.setCommissioner(this.user.get('id'));
			this.invites.remove(this.invites.where({
				first_name: '',
				email:      ''
			}));
			this.invites.add({});
			if (this.isCanAccess()) {
				this.trigger('leagues:manage:menu', this.league);
				this.setTemplateData({
					league:  this.league.toJSON(),
					invites: this.invites.toJSON()
				});
			}

			return this;
		},
		isCanAccess: function() {
			if (!this.league.get('id')) {
				this.trigger('leagues:http_status:404');

				return false;
			}
			else if (!this.league.get('is_commissioner')) {
				this.trigger('leagues:http_status:403');

				return false;
			}

			return true;
		},
		setTemplateData: function(obj) {
			_.extend(this.data, obj);
			this.getting_data = true;
			this.render();

			return this;
		},
		render: function() {
			if (!this.getting_data) {
				return this;
			}
			this.$el.html(this.template(this.data));

			return this;
		},
		sendInvites: function() {
			var invites = this.invites.toJSON();

			invites = _.filter(invites, function(invite) { return invite.first_name.length && invite.email.length; });
			if (invites.length) {
				this.showPreloader();
				this.league.invite(invites);
			}

			return this;
		},
		changeInvite: function(e) {
			var $el  = $(e.currentTarget),
				data = {};

			data[$el.data('field')] = $el.val();
			this.invites.at($el.data('id')).set(data);

			return this;
		},
		shareInvite: function(e) {
			var $el = $(e.currentTarget);

			this.share.invite({
				type:            $el.data('type'),
				team:            this.user.get('team_name'),
				team_id:         this.league.get('team_id'),
				league:          this.league.get('name'),
				is_commissioner: this.league.get('is_commissioner'),
				league_id:       this.league_id,
				user_id:         this.user.get('id'),
				code:            this.league.get('code')
			});

			return this;
		},
		showModal: function() {
			var $modal = $(this.ui.modal);

			if ($modal.is(':visible')) {
				this.closeModal();
			}
			this.getGoogleContacts();

			return this;
		},
		getGoogleContacts: function() {
			var auth_cnf = { client_id: this.google_config.client_id, scope: this.google_config.scope, immediate: false };

			this.google_contacts = [];
			gapi.client.setApiKey(this.google_config.api_key);
			gapi.auth.authorize(auth_cnf, _.bind(function(auth) {
				if (_.isUndefined(auth.error)) {
					$(this.ui.modal_container).removeClass('hidden');
					this.showPreloader();
					$.ajax({
						url: this.google_config.url_template({
							access_token: auth.access_token,
							max_results: this.google_config.max_results,
							v: this.google_config.v
						}),
						dataType: 'json',
						success: _.bind(function (data) {
							this.hidePreloader();
							if (!_.isUndefined(data.feed.entry)) {
								_.each(data.feed.entry, _.bind(function (entry) {
									if (!_.isUndefined(entry.gd$email) && !_.isUndefined(entry.title.$t) && entry.title.$t.length) {
										this.google_contacts.push({
											name: entry.title.$t,
											email: entry.gd$email[0].address
										});
									}
								}, this));
								this.google_contacts.sort(function compare(a,b) {
									if (a.name < b.name) {
										return -1;
									}
									else if (a.name > b.name) {
										return 1;
									}
									else {
										return 0;
									}
								});
								this.renderModalContent();
							}
						}, this)
					});
				}
			}, this));

			return this;
		},
		renderModalContent: function() {
			var content = '';
			if (this.google_contacts.length) {
				content += '<ul>' +
					'<li><label class="base-checkbox"><span>Select All</span>' +
					'<input type="checkbox" class="' + this.ui.select_all.slice(1) +  '"><i></i></label></li>';
				_.each(this.google_contacts, _.bind(function(contact) {
					content += '<li>' + this.google_config.contact_template({
							class_name: this.ui.select.slice(1),
							name:       contact.name,
							email:      contact.email
						}) + '</li>';
				}, this));
				content += '</ul>';
			}
			else {
				content += '<p class="empty-result">Not found contacts with email!</p>';
			}
			$(this.ui.modal_content).html(content);

			return this;
		},
		toggleModalCheckbox: function(e) {
			var $select     = $(this.ui.select),
				$select_all = $(this.ui.select_all);
			if ($(e.currentTarget).is($select_all)) {
				$select.prop('checked', $select_all.is(':checked'));
			}
			else {
				$select_all.prop('checked', $(this.ui.select + ':checked').length === $select.length)
			}
			return this;
		},
		submitModal: function(e) {
			e.preventDefault();

			_.each($(this.ui.select + ':checked'), _.bind(function(contact) {
				this.invites.add({
					first_name: $(contact).data('name'),
					email:      $(contact).data('email')
				});
			}, this));


			this.sendInvites();

			return this;
		},
		closeModal: function() {
			$(this.ui.modal_container).addClass('hidden');
			$(this.ui.modal_content).html('');

			return this;
		},
		invitesSent: function() {
			this.hidePreloader();
			APP.vent.trigger('popup:message:show', 'Your invites have been sent!');
			this.trigger('leagues_invites:success', this.league_id);

			return this;
		},
		changeLeague: function(league_id) {
			this.league_id = league_id;

			var complete = [
				this.league.show().fetch({ data:{ id: this.league_id } })
			];

			$.when.apply(null, complete).done(_.bind(this.initData, this));
		}
	});

}(window, APP, Backbone, Marionette, $, _));